import createVueComponent from '../createVueComponent';

const Framer = createVueComponent('FramerIcon', [
  ['path', { d: 'M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7', key: '1a2nng' }],
]);

export default Framer;
